module.exports = __webpack_public_path__ + "static/img/page_PLAY02.ba2aed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series6-moocs/course3/page_PLAY02.png
// module id = 0FY8
// module chunks = 0